import { render, staticRenderFns } from "./MessagesCommunications.vue?vue&type=template&id=0654349c"
import script from "./MessagesCommunications.vue?vue&type=script&lang=ts"
export * from "./MessagesCommunications.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports